import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableExpandBtnComponent } from './table-expand-btn/table-expand-btn.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from 'src/app/core';
import { HttpClient } from '@angular/common/http';

@NgModule({
  declarations: [TableExpandBtnComponent],
  imports: [
    CommonModule,
    NzButtonModule,
    TranslateModule.forChild({
      extend: true,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [TableExpandBtnComponent],
})
export class TablesModule {}
